import HelperService from "../services/helper-service";
import {ThemeColorMap} from "../utils/constants";


export default function InitialsAvatar({ user, width="30", ...props}) {
  return (
    <>
      <div className={"d-flex align-items-center align-content-center"}>
        <img
          src={HelperService.createImageFromInitials(width, HelperService.getInitials(user), ThemeColorMap[user?.id % ThemeColorMap.length])}
          width={`${width}px`}
          alt={user?.name}
          title={user?.name}
          className="rounded-circle generate-user-image" />
        <span className="d-none">{user?.name}</span>
      </div>
    </>
  );
}
